export default {
    imagePreviewPopupName: 'preview-popup',
};
